<section class="talleres" id="talleres">

  <!-- Heading — centrado per Figma (layout_RBIL6V: column, center, gap 48px) -->
  <div class="talleres__heading">
    <span class="tag tag-filled">
      <span class="dot"></span>
      Grupos reducidos. plazas limitadas.
    </span>
    <div class="talleres__heading-text">
      <h2 class="h2" style="color: var(--color-primary-950); text-align: center;">Planes creativos para los próximos días</h2>
      <p class="body-m" style="color: var(--color-neutral-950); text-align: center;">
        Elige el que mejor encaje contigo y ven a disfrutar de una experiencia creativa en Almería.
      </p>
    </div>
  </div>

  <!-- Cards — columna vertical, cada card es fila horizontal en desktop -->
  <div class="talleres__cards">
    @for (taller of talleres; track taller.title) {
      <article class="talleres__card">

 

        <!-- Derecha: contenido -->
        <div class="talleres__card-content">

          <button class="btn btn-primary talleres__cta" (click)="openContacto()">
            Me apunto
          </button>

          <!-- Info: descripción + datos en fila -->
          <div class="talleres__card-info">
            <div class="talleres__card-description">
              <h3 class="h3-s" style="color: var(--color-primary-950);">{{ taller.title }}</h3>
              <p class="body-s" style="color: var(--color-neutral-950);">{{ taller.description }}</p>
            </div>
            <div class="talleres__card-data">
              <div class="talleres__benefit">
                <span class="talleres__dot"></span>
                <span class="label-caps" style="color: var(--color-neutral-950);">{{ taller.benefit }}</span>
              </div>
              <div class="talleres__benefit">
                <span class="label-caps" style="color: var(--color-neutral-950);">Precio</span>
                <span class="talleres__price-badge">
                  <span class="body-m" style="color: var(--color-primary-950); font-weight: 500;">{{ taller.price }}</span>
                </span>
              </div>
              <div class="talleres__benefit">
                <span class="label-caps" style="color: var(--color-neutral-950);">lugar</span>
                <span class="talleres__price-badge">
                  <span class="body-m" style="color: var(--color-primary-950);">{{ taller.lugar }}</span>
                </span>
              </div>
              <div class="talleres__benefit">
                <span class="label-caps" style="color: var(--color-neutral-950);">fecha</span>
                <span class="talleres__price-badge">
                  <span class="body-m" style="color: var(--color-primary-950);">{{ taller.fecha }}</span>
                </span>
              </div>
            </div>
          </div>

        </div>
      </article>
    }
  </div>

</section>
